import { Grid } from '@material-ui/core';
import {
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityLayout
} from '@backstage/plugin-catalog';
import { GithubIssuesPage } from '@backstage-community/plugin-github-issues';
import {
  EntityGithubPullRequestsContent,
  isGithubPullRequestsAvailable
} from '@roadiehq/backstage-plugin-github-pull-requests';
import {
  EntityGithubDependabotContent,
  EntitySecurityInsightsContent
} from '@roadiehq/backstage-plugin-security-insights';
import {
  EntityGithubInsightsContent,
  isGithubInsightsAvailable
} from '@roadiehq/backstage-plugin-github-insights';
import { EntityConsumedApisCard, EntityProvidedApisCard } from '@backstage/plugin-api-docs';
import { EntityKubernetesContent } from '@backstage/plugin-kubernetes';
import {
  EntityTerraformContent,
  isTerraformAvailable
} from '@globallogicuki/backstage-plugin-terraform';
import { overviewContent } from './overviewContent';
import { cicdContent, isCicdAvailable } from './cicdContent';
import { techdocsContent } from './techdocsContent';
import {
  isGitHubDependabotAvailable,
  isGitHubIssuesAvailable,
  isGitHubSecurityInsightsAvailable,
  isKubernetesAvailable
} from '../../utils';

export type ServcieEntityPageProps = {
  overview?: React.JSX.Element;
  additionalRoutes?: React.JSX.Element;
}
export const serviceEntityPage = (props?: ServcieEntityPageProps) => (
  <EntityLayout>

    <EntityLayout.Route path="/" title="Overview">
      {props?.overview ?? overviewContent()}
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="CI/CD" if={isCicdAvailable}>
      {cicdContent()}
    </EntityLayout.Route>

    <EntityLayout.Route path="/terraform" title="Terraform" if={isTerraformAvailable}>
      <EntityTerraformContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/pull-requests" title="Pull Requests" if={isGithubPullRequestsAvailable}>
      <EntityGithubPullRequestsContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/issues" title="Issues" if={isGitHubIssuesAvailable}>
      <GithubIssuesPage />
    </EntityLayout.Route>

    <EntityLayout.Route path="/dependabot" title="Dependabot" if={isGitHubDependabotAvailable}>
      <EntityGithubDependabotContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/security-insights" title="Security Insights" if={isGitHubSecurityInsightsAvailable}>
      <EntitySecurityInsightsContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/code-insights" title="Code Insights" if={isGithubInsightsAvailable}>
      <EntityGithubInsightsContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/api" title="API">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityProvidedApisCard />
        </Grid>
        <Grid item md={6}>
          <EntityConsumedApisCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/kubernetes" title="Kubernetes" if={isKubernetesAvailable}>
      <EntityKubernetesContent refreshIntervalMs={30000}/>
    </EntityLayout.Route>

    {props?.additionalRoutes}

    <EntityLayout.Route path="/dependencies" title="Dependencies">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityDependsOnComponentsCard />
        </Grid>
        <Grid item md={6}>
          <EntityDependsOnResourcesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent()}
    </EntityLayout.Route>
  </EntityLayout>
);
